module.exports = __webpack_public_path__ + "static/media/Globe.dda1e133.svg";